import { Action } from 'redux';

export const SET_POSTAGE_FEES = 'super-admin-define-global-fees/SET_POSTAGE_FEES';
export const SET_POSTAGE_FEES_COMPLETE = 'super-admin-define-global-fees/SET_POSTAGE_FEES_COMPLETE';
export const CREATE_DEFINE_GLOBAL_FEES = 'super-admin-define-global-fees/CREATE_DEFINE_GLOBAL_FEES';
export const SET_EDITABLE_POSTAGE_FEES = 'super-admin-define-global-fees/SET_EDITABLE_POSTAGE_FEES';
export const SET_EDITABLE_POSTAGE_FEES_COMPLETE = 'super-admin-define-global-fees/SET_EDITABLE_POSTAGE_FEES_COMPLETE';
export const GET_POSTAGE_FEES_CONTEXT = 'super-admin-define-global-fees/GET_POSTAGE_FEES_CONTEXT';
export const SET_POSTAGE_FEES_CONTEXT = 'super-admin-define-global-fees/SET_POSTAGE_FEES_CONTEXT';

export const setPostageFees = (data: any) => {
  return {
    type: SET_POSTAGE_FEES,
    payload: data,
  };
};

export const setPostageFeesComplete = (data: any) => {
  return {
    type: SET_POSTAGE_FEES_COMPLETE,
    payload: data,
  };
};
export const createDefineGlobalFees = (data: any) => {
  return {
    type: CREATE_DEFINE_GLOBAL_FEES,
    payload: data,
  };
};
export const setEditablePostageFeesYN = (data: boolean) => {
  return {
    type: SET_EDITABLE_POSTAGE_FEES,
    payload: data,
  };
};
export const setEditablePostageFeesYNComplete = (data: boolean) => {
  return {
    type: SET_EDITABLE_POSTAGE_FEES_COMPLETE,
    payload: data,
  };
};
export const setPostageFeesContext = (data: any) => {
  return {
    type: SET_POSTAGE_FEES_CONTEXT,
    payload: data,
  };
};

export const getPostageFeesContext = () => {
  return {
    type: GET_POSTAGE_FEES_CONTEXT,
  };
};

export interface SetPostageFeesAction extends Action<typeof SET_POSTAGE_FEES_COMPLETE> {
  payload: any;
}
export interface SetEditablePostageFeesAction extends Action<typeof SET_EDITABLE_POSTAGE_FEES_COMPLETE> {
  payload: boolean;
}

export interface SetPostageFeesContextAction extends Action<typeof SET_POSTAGE_FEES_CONTEXT> {
  payload: any;
}

export type SuperAdminDefineGlobalFeesAction =
  SetPostageFeesAction | SetEditablePostageFeesAction | SetPostageFeesContextAction;
